<template>
    <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="slide-x-transition"
        @click:outside="$emit('close')"
        role="dialog"
        aria-modal="true"
        aria-labelledby="addq-title"
        aria-describedby="addq-desc">
        <v-card v-focus-trap="dialog" role="document">
            <div class="backsheet"></div>

            <!-- Close -->
            <v-btn class="close-btn" absolute top right icon color="primary" type="button" aria-label="Close dialog" @click="$emit('close')">
                <v-icon aria-hidden="true">mdi-close</v-icon>
            </v-btn>

            <v-card-text class="pt-5 pb-0">
                <div id="addq-title" class="lbl pb-1">ENTER ADDITIONAL QUESTION</div>
                <p id="addq-desc" class="sr-only">Enter an additional question and confirm with OK or press Enter.</p>

                <v-text-field
                    data-focus-first
                    @keyup.enter="addQuestion"
                    class="my-2"
                    rounded
                    filled
                    v-model="question"
                    label="Additional question"
                    hint="Separate multiple questions with a comma"
                    persistent-hint
                    :aria-describedby="'addq-desc'" />
            </v-card-text>

            <v-card-actions>
                <v-btn class="mx-auto" color="primary" rounded type="button" aria-label="Confirm additional question" @click="addQuestion"> ok </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Snackbar as live region -->
        <v-snackbar v-if="notification" top v-model="notification.show" :color="notification.color" role="status" aria-live="polite" aria-atomic="true" :aria-describedby="'snackbar-text'">
            <v-icon aria-hidden="true">{{ notification.icon }}</v-icon>
            <span id="snackbar-text" class="font-weight-bold pl-2">
                {{ notification.message }}
            </span>
        </v-snackbar>
    </v-dialog>
</template>

<script>
    // import datasources from "../helper/datasources.js"
    // import locs from "../helper/locs"

    export default {
        props: {
            show: Boolean
        },
        data() {
            return {
                // selectedLocation: localStorage.selectedLocation ? JSON.parse(localStorage.selectedLocation) : null,
                // selectedLocation: locs.stateItems[locs.stateItems.findIndex((x) => x.loc == "Germany")],
                // selectedLocation: localStorage.selectedLocation ? JSON.parse(localStorage.selectedLocation) : locs.stateItems[locs.stateItems.findIndex((x) => x.loc == "Germany")],
                question: "",
                notification: null
            }
        },
        computed: {
            dialog() {
                return this.show
            }
        },
        methods: {
            trackEvent(component, action, param1, param2) {
                try {
                    this.$matomo.trackEvent(component, action, param1, param2)
                } catch (error) {
                    console.log(error)
                    console.log("matomo blocked")
                }
            },
            async addQuestion() {
                try {
                    if (this.question == "") return

                    this.$emit("added", this.question)
                    this.$emit("close")

                    this.question = ""
                } catch (error) {
                    console.log(error)
                    this.$emit("failed")
                    this.question = ""
                }
            }
        }
    }
</script>

<style scoped>
    .close-btn {
        top: 5px;
        right: 5px;
    }
</style>
